import React from 'react';
import DataTables from './DataTables';

export default DataTables;

interface Sizing {
  label: string;
  value: number;
}
export interface DataTablesProps {
  columns: DataTableColumn[];
  data: any[];
  activeSize?: number;
  currentSize?: number;
  currentPage?: number;
  sizing?: Sizing[];
  loading?: boolean;
  isNumbering?: boolean;
  viewText?: string;
  deleteText?: string;
  editText?: string;
  copyText?: string;
  approvedText?: string;
  rejectedText?: string;
  totalData?: number;
  handleView?: (_data: any) => void;
  handleEdit?: (_data: any) => void;
  handleApproved?: (_data: any) => void;
  handleRejected?: (_data: any) => void;
  handleDelete?: (_data: any) => void;
  handleCopy?: (_data: any) => void;
  handleChangeSize?: (_size: number) => void;
  handleChangePage?: (_page: number) => void;
  emptyMessage?: React.ReactNode | string;
  emptyMessageTitle?: string;
  emptyMessageDescription?: string;
  urlEmptyImage?: string;
  withPagination?: boolean;
  withBulkData?: boolean;
  canView?: (_data: any) => boolean;
  canEdit?: (_data: any) => boolean;
  canDelete?: (_data: any) => boolean;
  canApproved?: (_data: any) => boolean;
  canRejected?: (_data: any) => boolean;
  onSortChange?: (_sortBy: string, _sortOrder: 'asc' | 'desc') => void;
}

export interface DataTableColumn {
  heading: React.ReactNode;
  props: any;
  id?: string;
  align?: 'left' | 'center' | 'right' | 'justify' | 'char' | undefined;
  width?: number;
  sortable?: boolean;
  active?: boolean;
  disabled?: boolean;
}

export type SortDirection = 'asc' | 'desc' | null;

export interface SortedConfigurationTable {
  key: string | null;
  direction: SortDirection;
}

export interface DataTableHeadProps {
  columns: DataTableColumn[];
  data: any[];
  sortConfig: SortedConfigurationTable;
  isNumbering?: boolean;
  onSort?: (_data: any) => void;
}

export interface DataTableBodyProps {
  columns: DataTableColumn[];
  data: any[];
  rawData?: any[];
  isNumbering?: boolean;
  noDelete?: boolean;
  activePage?: number;
  activePageSize?: number;
  viewText?: string;
  deleteText?: string;
  editText?: string;
  copyText?: string;
  approvedText?: string;
  rejectedText?: string;
  emptyMessage?: React.ReactNode | string;
  emptyMessageTitle?: string;
  emptyMessageDescription?: string;
  urlEmptyImage?: string;
  handleView?: (_data: any) => void;
  handleEdit?: (_data: any) => void;
  handleDelete?: (_data: any) => void;
  handleApproved?: (_data: any) => void;
  handleRejected?: (_data: any) => void;
  handleCopy?: (_data: any) => void;
  canView?: (_data: any) => boolean;
  canEdit?: (_data: any) => boolean;
  canDelete?: (_data: any) => boolean;
  canApproved?: (_data: any) => boolean;
  canRejected?: (_data: any) => boolean;
}
